import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  data(){
    return {
      yMaxValue: this.chartData.datasets[0].y_max || null,
      options: {
        plugins : {
            legend: {
                display: false,
                position: "bottom",
                padding: 25,
                labels: {
                    font: {

                    }

                }
            },
            tooltip: {
                callbacks: {
                    title: () => "",
                    label: function(context) {
                        let label = context.dataset.label || '';
                        let index = (context.dataIndex)
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += context.dataset.tooltips[index];

                        }
                        if (context.dataset.tooltips[index] === "") {
                          let l = ""
                          return [l];
                        } else {
                          return [label];
                        }

                    }
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
              beginAtZero: true,
              position: 'left',
              max: this.chartData.datasets[0].y_max,
              grid: {
                display: true,
                color: "#e4e6e8",

              },
              ticks: {
                maxTicksLimit: 10,
                font: {
                  size: 10
                },
              }
            },
            x: {
              grid: {
                display: false
              },
              ticks: {
                maxTicksLimit: 10,
                font: {
                  size: 10
                },
                maxRotation: 0,
                minRotation: 0,
              },
            },

        },

      }
    }
  },
  mounted () {
    this.renderChart(
      this.chartData,
      this.options
      )
  }
}
